import {createFileRoute} from '@tanstack/react-router'

import AdsScreen from '@protected/ads'

export const Route = createFileRoute('/_protected/meta')({component: () => <AdsScreen platform="meta" />})
